import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "text-sm text-(--colors-text-body-subtle)",
    "data-testid": "donation-settings-numbering-required-hint"
};
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" };
import { Alert, Badge, RadioForm, RadioFormGroup, SelectInput, TextInput } from "@eudonet/opal";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { TAX_RECEIPT_COUNTER_SIZES, TAX_RECEIPT_NUMBERING_MODES, TAX_RECEIPT_PREFIX_MAX_LENGTH, } from "../../../domain/entities/taxReceiptSettings";
import DonationSettingsFieldError from "./DonationSettingsFieldError.vue";
import DonationSettingsSection from "./DonationSettingsSection.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsNumberingTab',
    props: {
        numberingMode: {},
        numberingPrefix: {},
        numberingCounterSize: {},
        numberingLocked: { type: Boolean },
        numberPreview: {},
        numberingModeError: {},
        numberingPrefixError: {},
        numberingCounterSizeError: {}
    },
    emits: ["update:numberingMode", "update:numberingPrefix", "update:numberingCounterSize"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const { t } = useI18n();
        const annualBadges = computed(() => [
            { label: t("finance.taxReceipts.settings.numbering.annualRecommended"), theme: "indigo" },
        ]);
        const counterSizeOptions = computed(() => TAX_RECEIPT_COUNTER_SIZES.map((size) => ({
            value: String(size),
            label: t("finance.taxReceipts.settings.numbering.counterSizeOption", {
                size,
                example: "1".padStart(size, "0"),
            }),
        })));
        function onModeChange(value) {
            const mode = TAX_RECEIPT_NUMBERING_MODES.find((candidate) => candidate === value);
            if (mode)
                emit("update:numberingMode", mode);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DonationSettingsSection, {
                title: _ctx.$t('finance.taxReceipts.settings.numbering.title'),
                subtitle: __props.numberingLocked
                    ? _ctx.$t('finance.taxReceipts.settings.numbering.lockedHelp')
                    : _ctx.$t('finance.taxReceipts.settings.numbering.unlockedHelp'),
                "test-id": "donation-settings-numbering"
            }, {
                badge: _withCtx(() => [
                    _createVNode(_unref(Badge), {
                        label: __props.numberingLocked
                            ? _ctx.$t('finance.taxReceipts.settings.numbering.lockedBadge')
                            : _ctx.$t('finance.taxReceipts.settings.numbering.unlockedBadge'),
                        theme: __props.numberingLocked ? 'neutral' : 'green',
                        size: "sm",
                        "show-close-icon": false,
                        "data-testid": "donation-settings-numbering-lock",
                        "left-icon": __props.numberingLocked ? 'ri-lock-line' : 'ri-lock-unlock-line'
                    }, null, 8 /* PROPS */, ["label", "theme", "left-icon"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("finance.taxReceipts.settings.requiredFieldsHint")), 1 /* TEXT */),
                    _createVNode(_unref(RadioFormGroup), {
                        "aria-label": _ctx.$t('finance.taxReceipts.settings.numbering.modeLabel'),
                        class: "flex flex-col gap-3"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(RadioForm), {
                                "model-value": __props.numberingMode,
                                value: "AnnualCounter",
                                name: "donation-settings-numbering-mode",
                                label: _ctx.$t('finance.taxReceipts.settings.numbering.annualLabel'),
                                helper: _ctx.$t('finance.taxReceipts.settings.numbering.annualHelper'),
                                badges: annualBadges.value,
                                disabled: __props.numberingLocked,
                                "data-testid": "donation-settings-numbering-mode-annual",
                                "onUpdate:modelValue": onModeChange
                            }, null, 8 /* PROPS */, ["model-value", "label", "helper", "badges", "disabled"]),
                            _createVNode(_unref(RadioForm), {
                                "model-value": __props.numberingMode,
                                value: "GlobalCounter",
                                name: "donation-settings-numbering-mode",
                                label: _ctx.$t('finance.taxReceipts.settings.numbering.globalLabel'),
                                helper: _ctx.$t('finance.taxReceipts.settings.numbering.globalHelper'),
                                disabled: __props.numberingLocked,
                                "data-testid": "donation-settings-numbering-mode-global",
                                "onUpdate:modelValue": onModeChange
                            }, null, 8 /* PROPS */, ["model-value", "label", "helper", "disabled"]),
                            _createVNode(DonationSettingsFieldError, {
                                message: __props.numberingModeError ? _ctx.$t(__props.numberingModeError) : undefined,
                                "test-id": "donation-settings-numbering-mode-error"
                            }, null, 8 /* PROPS */, ["message"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["aria-label"]),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_unref(TextInput), {
                            "model-value": __props.numberingPrefix,
                            label: _ctx.$t('finance.taxReceipts.settings.numbering.prefixLabel'),
                            hint: _ctx.$t('finance.taxReceipts.settings.numbering.prefixHint'),
                            error: __props.numberingPrefixError ? _ctx.$t(__props.numberingPrefixError) : undefined,
                            disabled: __props.numberingLocked,
                            maxlength: _unref(TAX_RECEIPT_PREFIX_MAX_LENGTH),
                            required: "",
                            autocomplete: "off",
                            "full-width": "",
                            "data-testid": "donation-settings-numbering-prefix",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (emit('update:numberingPrefix', $event.toUpperCase())))
                        }, null, 8 /* PROPS */, ["model-value", "label", "hint", "error", "disabled", "maxlength"]),
                        _createVNode(_unref(SelectInput), {
                            "model-value": __props.numberingCounterSize,
                            options: counterSizeOptions.value,
                            label: _ctx.$t('finance.taxReceipts.settings.numbering.counterSizeLabel'),
                            error: __props.numberingCounterSizeError ? _ctx.$t(__props.numberingCounterSizeError) : undefined,
                            disabled: __props.numberingLocked,
                            "full-width": "",
                            "data-testid": "donation-settings-numbering-counter-size",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (emit('update:numberingCounterSize', $event)))
                        }, null, 8 /* PROPS */, ["model-value", "options", "label", "error", "disabled"])
                    ]),
                    _createVNode(_unref(TextInput), {
                        "model-value": __props.numberPreview,
                        label: _ctx.$t('finance.taxReceipts.settings.numbering.previewLabel'),
                        readonly: "",
                        "full-width": "",
                        "data-testid": "donation-settings-numbering-preview"
                    }, null, 8 /* PROPS */, ["model-value", "label"]),
                    _createVNode(_unref(Alert), {
                        color: "info",
                        message: _ctx.$t('finance.taxReceipts.settings.numbering.uniquenessRule'),
                        "data-testid": "donation-settings-numbering-uniqueness-rule"
                    }, null, 8 /* PROPS */, ["message"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "subtitle"]));
        };
    }
});
